// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type RecurringEventDetailEditQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RecurringEventDetailEditQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & RecurringEventDetailFragment
    )> }
  )> }
);

export type RecurringEventRelatedEntitiesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RecurringEventRelatedEntitiesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { relatedCampaigns: Array<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name' | 'actionsCount'>
      )> }
    )> }
  )> }
);

export type AffectedCampaignsAfterPatchQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  data: PrivateSchemaTypes.RecurringEventModelInput;
}>;


export type AffectedCampaignsAfterPatchQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { affectedCampaignsAfterPatch: Array<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name' | 'actionsCount'>
      )> }
    )> }
  )> }
);

export type RecurringEventPatchMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  data: PrivateSchemaTypes.RecurringEventModelInput;
  tags?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type RecurringEventPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventModelAsAdmin' }
        & RecurringEventPatchFragment
      )> }
    )> }
  )> }
);

export type PatchRecurringEventAndNotifyMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  notifyRSVPdInvitees?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  data: PrivateSchemaTypes.RecurringEventModelInput;
  tags?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.Scalars['PositiveInt']> | PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type PatchRecurringEventAndNotifyMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'update_email_sent_at' | 'updated_at'>
        & { sendUpdatedEmailToAllInvitees?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'RecurringEventModelAsAdmin' }
          & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'update_email_sent_at' | 'updated_at'>
        )> }
        & RecurringEventPatchFragment
      )> }
    )> }
  )> }
);

export type CancelRecurringEventMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendCancellationEmail: PrivateSchemaTypes.Scalars['Boolean'];
  emailIdentityId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type CancelRecurringEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'delete'>
    )> }
  )> }
);

export type PublishRecurringEventMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type PublishRecurringEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'publish'>
    )> }
  )> }
);

export type TransformRecurringEventToEventMutationVariables = PrivateSchemaTypes.Exact<{
  recEventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  date?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['String']>;
}>;


export type TransformRecurringEventToEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { transformRecurringEventToRegularEvent?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title'>
      )> }
    )> }
  )> }
);

export type CreateRecurringEventBasedOnRegularEventMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['Float'];
  recurrence: PrivateSchemaTypes.EventRecurrencePatternInput;
  attendanceType: PrivateSchemaTypes.Scalars['String'];
}>;


export type CreateRecurringEventBasedOnRegularEventMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { createRecurringEventBasedOnRegularEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
    )> }
  )> }
);

export type RecurringEventDetailFragment = (
  { __typename?: 'RecurringEventModelAsAdmin' }
  & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'title' | 'location' | 'start_time' | 'end_time' | 'timezone' | 'description' | 'participants_limit' | 'update_email_sent_at' | 'allow_comments' | 'attendeesCount' | 'inviteesCount' | 'attendance_type' | 'updated_at' | 'is_open' | 'published_date' | 'google_meet_uuid' | 'google_meet_id'>
  & { tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  ), facilitator?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'display_name' | 'image_url' | 'id' | 'userIdentity'>
  )>, recurrence?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'EventRecurrencePattern' }
    & Pick<PrivateSchemaTypes.EventRecurrencePattern, 'interval' | 'count' | 'byDay' | 'freq'>
  )>, events: Array<(
    { __typename?: 'EventModelAsAdmin' }
    & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title' | 'location' | 'start_time' | 'published_date' | 'end_time' | 'timezone' | 'is_open' | 'attendeesCount' | 'presentCount'>
  )> }
);

export type RecurringEventPatchFragment = (
  { __typename?: 'RecurringEventModelAsAdmin' }
  & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'title' | 'location' | 'start_time' | 'end_time' | 'timezone' | 'description' | 'participants_limit' | 'allow_comments' | 'attendance_type' | 'attendeesCount' | 'is_open' | 'published_date' | 'facilitator_id' | 'update_email_sent_at' | 'updated_at'>
  & { recurrence?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'EventRecurrencePattern' }
    & Pick<PrivateSchemaTypes.EventRecurrencePattern, 'count' | 'byDay' | 'byYear' | 'byMonth' | 'freq' | 'interval'>
  )>, tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, author: (
    { __typename?: 'UserModelPublicBase' }
    & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
  ) }
);

export const RecurringEventDetailFragmentDoc = gql`
    fragment recurringEventDetail on RecurringEventModelAsAdmin {
  id
  title
  location
  start_time
  end_time
  timezone
  description
  participants_limit
  update_email_sent_at
  allow_comments
  attendeesCount
  inviteesCount
  attendance_type
  updated_at
  is_open
  published_date
  google_meet_uuid
  google_meet_id
  tags {
    id
    name
  }
  author {
    id
    display_name
  }
  facilitator {
    display_name
    image_url
    id
    userIdentity
  }
  recurrence {
    interval
    count
    byDay
    freq
  }
  events {
    id
    title
    location
    start_time
    published_date
    end_time
    timezone
    is_open
    attendeesCount
    presentCount
  }
}
    `;
export const RecurringEventPatchFragmentDoc = gql`
    fragment recurringEventPatch on RecurringEventModelAsAdmin {
  id
  title
  location
  start_time
  end_time
  timezone
  description
  participants_limit
  allow_comments
  attendance_type
  attendeesCount
  is_open
  published_date
  recurrence {
    count
    byDay
    byYear
    byMonth
    freq
    interval
  }
  tags {
    id
    name
  }
  author {
    id
    display_name
  }
  facilitator_id
  update_email_sent_at
  updated_at
}
    `;
export const RecurringEventDetailEditDocument = gql`
    query recurringEventDetailEdit($eventId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      ...recurringEventDetail
    }
  }
}
    ${RecurringEventDetailFragmentDoc}`;

/**
 * __useRecurringEventDetailEditQuery__
 *
 * To run a query within a React component, call `useRecurringEventDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringEventDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringEventDetailEditQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRecurringEventDetailEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringEventDetailEditQuery, RecurringEventDetailEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringEventDetailEditQuery, RecurringEventDetailEditQueryVariables>(RecurringEventDetailEditDocument, options);
      }
export function useRecurringEventDetailEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringEventDetailEditQuery, RecurringEventDetailEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringEventDetailEditQuery, RecurringEventDetailEditQueryVariables>(RecurringEventDetailEditDocument, options);
        }
export type RecurringEventDetailEditQueryHookResult = ReturnType<typeof useRecurringEventDetailEditQuery>;
export type RecurringEventDetailEditLazyQueryHookResult = ReturnType<typeof useRecurringEventDetailEditLazyQuery>;
export type RecurringEventDetailEditQueryResult = Apollo.QueryResult<RecurringEventDetailEditQuery, RecurringEventDetailEditQueryVariables>;
export const RecurringEventRelatedEntitiesDocument = gql`
    query recurringEventRelatedEntities($eventId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      relatedCampaigns {
        id
        name
        actionsCount
      }
    }
  }
}
    `;

/**
 * __useRecurringEventRelatedEntitiesQuery__
 *
 * To run a query within a React component, call `useRecurringEventRelatedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringEventRelatedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringEventRelatedEntitiesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRecurringEventRelatedEntitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringEventRelatedEntitiesQuery, RecurringEventRelatedEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringEventRelatedEntitiesQuery, RecurringEventRelatedEntitiesQueryVariables>(RecurringEventRelatedEntitiesDocument, options);
      }
export function useRecurringEventRelatedEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringEventRelatedEntitiesQuery, RecurringEventRelatedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringEventRelatedEntitiesQuery, RecurringEventRelatedEntitiesQueryVariables>(RecurringEventRelatedEntitiesDocument, options);
        }
export type RecurringEventRelatedEntitiesQueryHookResult = ReturnType<typeof useRecurringEventRelatedEntitiesQuery>;
export type RecurringEventRelatedEntitiesLazyQueryHookResult = ReturnType<typeof useRecurringEventRelatedEntitiesLazyQuery>;
export type RecurringEventRelatedEntitiesQueryResult = Apollo.QueryResult<RecurringEventRelatedEntitiesQuery, RecurringEventRelatedEntitiesQueryVariables>;
export const AffectedCampaignsAfterPatchDocument = gql`
    query affectedCampaignsAfterPatch($eventId: PositiveInt!, $data: RecurringEventModelInput!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      affectedCampaignsAfterPatch(data: $data) {
        id
        name
        actionsCount
      }
    }
  }
}
    `;

/**
 * __useAffectedCampaignsAfterPatchQuery__
 *
 * To run a query within a React component, call `useAffectedCampaignsAfterPatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffectedCampaignsAfterPatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffectedCampaignsAfterPatchQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAffectedCampaignsAfterPatchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AffectedCampaignsAfterPatchQuery, AffectedCampaignsAfterPatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffectedCampaignsAfterPatchQuery, AffectedCampaignsAfterPatchQueryVariables>(AffectedCampaignsAfterPatchDocument, options);
      }
export function useAffectedCampaignsAfterPatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffectedCampaignsAfterPatchQuery, AffectedCampaignsAfterPatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffectedCampaignsAfterPatchQuery, AffectedCampaignsAfterPatchQueryVariables>(AffectedCampaignsAfterPatchDocument, options);
        }
export type AffectedCampaignsAfterPatchQueryHookResult = ReturnType<typeof useAffectedCampaignsAfterPatchQuery>;
export type AffectedCampaignsAfterPatchLazyQueryHookResult = ReturnType<typeof useAffectedCampaignsAfterPatchLazyQuery>;
export type AffectedCampaignsAfterPatchQueryResult = Apollo.QueryResult<AffectedCampaignsAfterPatchQuery, AffectedCampaignsAfterPatchQueryVariables>;
export const RecurringEventPatchDocument = gql`
    mutation recurringEventPatch($eventId: PositiveInt!, $data: RecurringEventModelInput!, $tags: [PositiveInt!]) {
  admin {
    recurringEvent(id: $eventId) {
      id
      patch(data: $data, tags: $tags) {
        ...recurringEventPatch
      }
    }
  }
}
    ${RecurringEventPatchFragmentDoc}`;
export type RecurringEventPatchMutationFn = Apollo.MutationFunction<RecurringEventPatchMutation, RecurringEventPatchMutationVariables>;

/**
 * __useRecurringEventPatchMutation__
 *
 * To run a mutation, you first call `useRecurringEventPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecurringEventPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recurringEventPatchMutation, { data, loading, error }] = useRecurringEventPatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      data: // value for 'data'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useRecurringEventPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecurringEventPatchMutation, RecurringEventPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecurringEventPatchMutation, RecurringEventPatchMutationVariables>(RecurringEventPatchDocument, options);
      }
export type RecurringEventPatchMutationHookResult = ReturnType<typeof useRecurringEventPatchMutation>;
export type RecurringEventPatchMutationResult = Apollo.MutationResult<RecurringEventPatchMutation>;
export type RecurringEventPatchMutationOptions = Apollo.BaseMutationOptions<RecurringEventPatchMutation, RecurringEventPatchMutationVariables>;
export const PatchRecurringEventAndNotifyDocument = gql`
    mutation patchRecurringEventAndNotify($eventId: PositiveInt!, $emailIdentityId: PositiveInt, $notifyRSVPdInvitees: Boolean, $data: RecurringEventModelInput!, $tags: [PositiveInt!]) {
  admin {
    recurringEvent(id: $eventId) {
      id
      patch(data: $data, tags: $tags) {
        ...recurringEventPatch
        update_email_sent_at
        updated_at
        sendUpdatedEmailToAllInvitees(
          emailIdentityId: $emailIdentityId
          notifyRSVPdInvitees: $notifyRSVPdInvitees
        ) {
          update_email_sent_at
          updated_at
        }
      }
    }
  }
}
    ${RecurringEventPatchFragmentDoc}`;
export type PatchRecurringEventAndNotifyMutationFn = Apollo.MutationFunction<PatchRecurringEventAndNotifyMutation, PatchRecurringEventAndNotifyMutationVariables>;

/**
 * __usePatchRecurringEventAndNotifyMutation__
 *
 * To run a mutation, you first call `usePatchRecurringEventAndNotifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchRecurringEventAndNotifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchRecurringEventAndNotifyMutation, { data, loading, error }] = usePatchRecurringEventAndNotifyMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emailIdentityId: // value for 'emailIdentityId'
 *      notifyRSVPdInvitees: // value for 'notifyRSVPdInvitees'
 *      data: // value for 'data'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function usePatchRecurringEventAndNotifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchRecurringEventAndNotifyMutation, PatchRecurringEventAndNotifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchRecurringEventAndNotifyMutation, PatchRecurringEventAndNotifyMutationVariables>(PatchRecurringEventAndNotifyDocument, options);
      }
export type PatchRecurringEventAndNotifyMutationHookResult = ReturnType<typeof usePatchRecurringEventAndNotifyMutation>;
export type PatchRecurringEventAndNotifyMutationResult = Apollo.MutationResult<PatchRecurringEventAndNotifyMutation>;
export type PatchRecurringEventAndNotifyMutationOptions = Apollo.BaseMutationOptions<PatchRecurringEventAndNotifyMutation, PatchRecurringEventAndNotifyMutationVariables>;
export const CancelRecurringEventDocument = gql`
    mutation cancelRecurringEvent($eventId: PositiveInt!, $sendCancellationEmail: Boolean!, $emailIdentityId: PositiveInt) {
  admin {
    recurringEvent(id: $eventId) {
      id
      delete(
        sendCancellationEmail: $sendCancellationEmail
        emailIdentityId: $emailIdentityId
      )
    }
  }
}
    `;
export type CancelRecurringEventMutationFn = Apollo.MutationFunction<CancelRecurringEventMutation, CancelRecurringEventMutationVariables>;

/**
 * __useCancelRecurringEventMutation__
 *
 * To run a mutation, you first call `useCancelRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRecurringEventMutation, { data, loading, error }] = useCancelRecurringEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      sendCancellationEmail: // value for 'sendCancellationEmail'
 *      emailIdentityId: // value for 'emailIdentityId'
 *   },
 * });
 */
export function useCancelRecurringEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelRecurringEventMutation, CancelRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelRecurringEventMutation, CancelRecurringEventMutationVariables>(CancelRecurringEventDocument, options);
      }
export type CancelRecurringEventMutationHookResult = ReturnType<typeof useCancelRecurringEventMutation>;
export type CancelRecurringEventMutationResult = Apollo.MutationResult<CancelRecurringEventMutation>;
export type CancelRecurringEventMutationOptions = Apollo.BaseMutationOptions<CancelRecurringEventMutation, CancelRecurringEventMutationVariables>;
export const PublishRecurringEventDocument = gql`
    mutation publishRecurringEvent($eventId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      publish
    }
  }
}
    `;
export type PublishRecurringEventMutationFn = Apollo.MutationFunction<PublishRecurringEventMutation, PublishRecurringEventMutationVariables>;

/**
 * __usePublishRecurringEventMutation__
 *
 * To run a mutation, you first call `usePublishRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishRecurringEventMutation, { data, loading, error }] = usePublishRecurringEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function usePublishRecurringEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishRecurringEventMutation, PublishRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishRecurringEventMutation, PublishRecurringEventMutationVariables>(PublishRecurringEventDocument, options);
      }
export type PublishRecurringEventMutationHookResult = ReturnType<typeof usePublishRecurringEventMutation>;
export type PublishRecurringEventMutationResult = Apollo.MutationResult<PublishRecurringEventMutation>;
export type PublishRecurringEventMutationOptions = Apollo.BaseMutationOptions<PublishRecurringEventMutation, PublishRecurringEventMutationVariables>;
export const TransformRecurringEventToEventDocument = gql`
    mutation transformRecurringEventToEvent($recEventId: PositiveInt!, $date: String) {
  admin {
    recurringEvent(id: $recEventId) {
      id
      transformRecurringEventToRegularEvent(eventId: null, startDateOfEvent: $date) {
        id
        title
      }
    }
  }
}
    `;
export type TransformRecurringEventToEventMutationFn = Apollo.MutationFunction<TransformRecurringEventToEventMutation, TransformRecurringEventToEventMutationVariables>;

/**
 * __useTransformRecurringEventToEventMutation__
 *
 * To run a mutation, you first call `useTransformRecurringEventToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransformRecurringEventToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transformRecurringEventToEventMutation, { data, loading, error }] = useTransformRecurringEventToEventMutation({
 *   variables: {
 *      recEventId: // value for 'recEventId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTransformRecurringEventToEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransformRecurringEventToEventMutation, TransformRecurringEventToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransformRecurringEventToEventMutation, TransformRecurringEventToEventMutationVariables>(TransformRecurringEventToEventDocument, options);
      }
export type TransformRecurringEventToEventMutationHookResult = ReturnType<typeof useTransformRecurringEventToEventMutation>;
export type TransformRecurringEventToEventMutationResult = Apollo.MutationResult<TransformRecurringEventToEventMutation>;
export type TransformRecurringEventToEventMutationOptions = Apollo.BaseMutationOptions<TransformRecurringEventToEventMutation, TransformRecurringEventToEventMutationVariables>;
export const CreateRecurringEventBasedOnRegularEventDocument = gql`
    mutation createRecurringEventBasedOnRegularEvent($eventId: Float!, $recurrence: EventRecurrencePatternInput!, $attendanceType: String!) {
  admin {
    createRecurringEventBasedOnRegularEvent(
      eventId: $eventId
      recurrence: $recurrence
      attendanceType: $attendanceType
    ) {
      id
    }
  }
}
    `;
export type CreateRecurringEventBasedOnRegularEventMutationFn = Apollo.MutationFunction<CreateRecurringEventBasedOnRegularEventMutation, CreateRecurringEventBasedOnRegularEventMutationVariables>;

/**
 * __useCreateRecurringEventBasedOnRegularEventMutation__
 *
 * To run a mutation, you first call `useCreateRecurringEventBasedOnRegularEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringEventBasedOnRegularEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringEventBasedOnRegularEventMutation, { data, loading, error }] = useCreateRecurringEventBasedOnRegularEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      recurrence: // value for 'recurrence'
 *      attendanceType: // value for 'attendanceType'
 *   },
 * });
 */
export function useCreateRecurringEventBasedOnRegularEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRecurringEventBasedOnRegularEventMutation, CreateRecurringEventBasedOnRegularEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRecurringEventBasedOnRegularEventMutation, CreateRecurringEventBasedOnRegularEventMutationVariables>(CreateRecurringEventBasedOnRegularEventDocument, options);
      }
export type CreateRecurringEventBasedOnRegularEventMutationHookResult = ReturnType<typeof useCreateRecurringEventBasedOnRegularEventMutation>;
export type CreateRecurringEventBasedOnRegularEventMutationResult = Apollo.MutationResult<CreateRecurringEventBasedOnRegularEventMutation>;
export type CreateRecurringEventBasedOnRegularEventMutationOptions = Apollo.BaseMutationOptions<CreateRecurringEventBasedOnRegularEventMutation, CreateRecurringEventBasedOnRegularEventMutationVariables>;